/**
 * Devuelve el header Authorization con el token JWT guardado en localStorage
 * (el mismo que usa AuthContext). Se usa en los servicios que todavía hacen
 * fetch/XHR directo en vez de la instancia axios `API` (que ya lo adjunta
 * automáticamente vía interceptor).
 */
export function authHeader() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export default authHeader;
